import {
  WizardStep,
  StepProps,
} from "@shared/components/application/navigation/Wizard/WizardStep.web";
import { useTrackRef } from "@shared/hooks/useTrackRef";

export interface PurchaseWizardModalStepCustomData {
  allowEmptyBasket?: boolean;
  allowExpiredBasket?: boolean;
  hideFooter?: boolean;
  hideNextButton?: boolean;
  onNext?:
    | (() => void)
    | (() => Promise<void>)
    | (() => boolean)
    | (() => Promise<boolean>);
}

export interface PurchaseWizardModalStepProps
  extends StepProps,
    PurchaseWizardModalStepCustomData {}

export const PurchaseWizardModalStep = (
  props: PurchaseWizardModalStepProps
) => {
  const {
    allowEmptyBasket,
    allowExpiredBasket,
    onNext,
    hideFooter,
    hideNextButton,
    ...rest
  } = props;
  const onNextRef = useTrackRef(onNext);

  const handleNext = () => onNextRef.current?.();
  const customData = {
    allowEmptyBasket,
    allowExpiredBasket,
    hideFooter,
    hideNextButton,
    onNext: handleNext,
  };

  return <WizardStep {...rest} customData={customData} />;
};
